module.exports = __webpack_public_path__ + "img/bd4f2bdb7b52b7639d91c89eb734acd5.2cdff27b.jpg";